// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3gezp","error":"Textarea_error__3tKip","readonly":"Textarea_readonly__5rZEY","disabled":"Textarea_disabled__2sg1v"};